import { HeadingTypeEnum } from 'common/enums/HeadingTypeEnum'

export const headingFontSize = {
  [HeadingTypeEnum.HeaderOne]: { fontSize: 40, lineHeight: 48 },
  [HeadingTypeEnum.HeaderTwo]: { fontSize: 32, lineHeight: 38.4 },
  [HeadingTypeEnum.HeaderThree]: { fontSize: 28, lineHeight: 33.6 },
  [HeadingTypeEnum.HeaderFour]: { fontSize: 24, lineHeight: 28.8 },
  [HeadingTypeEnum.HeaderFive]: { fontSize: 20, lineHeight: 24 },
  [HeadingTypeEnum.HeaderSix]: { fontSize: 16, lineHeight: 19.2 },
}

export const mobileHeadingFontSize = {
  [HeadingTypeEnum.HeaderOne]: { fontSize: 30, lineHeight: 36 },
  [HeadingTypeEnum.HeaderTwo]: { fontSize: 24, lineHeight: 28.8 },
  [HeadingTypeEnum.HeaderThree]: { fontSize: 22, lineHeight: 26.4 },
  [HeadingTypeEnum.HeaderFour]: { fontSize: 20, lineHeight: 24 },
  [HeadingTypeEnum.HeaderFive]: { fontSize: 16, lineHeight: 19.2 },
  [HeadingTypeEnum.HeaderSix]: { fontSize: 14, lineHeight: 16.8 },
}
